import { GridSize } from "@mui/material/Grid";

import { kebabCase } from "lodash";

import { SPEECH_AUDIOMETRY_TYPES } from "constants/audiology";
import {
  PatientReviewDetail,
  PatientReviewDetailGroup,
  PatientReviewDetailGroupTitle
} from "features/patients/sections/components";
import { SpeechAudiometryData } from "services/types/reports.type";
import { WordList } from "services/types/word-lists.type";

import PreviewWordList from "./preview-word-list.component";

type PreviewSpeechAudiometryDataGroupProps = {
  data?: SpeechAudiometryData;
  title: string;
  detailSize?: GridSize;
  wordListSize?: GridSize;
  titleSize?: GridSize;
};

export default function PreviewSpeechAudiometryDataGroup({
  data,
  title,
  detailSize,
  wordListSize,
  titleSize
}: PreviewSpeechAudiometryDataGroupProps) {
  return (
    <PatientReviewDetailGroup
      value={data}
      sm={6}
      testId={`speech-audiometry-data-${kebabCase(title)}`}
    >
      <PatientReviewDetailGroupTitle md={12} lg={titleSize} title={title} />
      <PreviewWordList data={data?.wordList as WordList} size={wordListSize} />
      <PatientReviewDetail
        title="Type"
        value={
          data?.type ? SPEECH_AUDIOMETRY_TYPES.getFromCode(data?.type) : "--"
        }
        size={detailSize}
        lg={1}
      />
      <PatientReviewDetail
        title="Value"
        value={data?.value ?? "--"}
        size={detailSize}
        lg={1}
      />
      <PatientReviewDetail
        title="Masking"
        value={data?.masking ?? "--"}
        size={detailSize}
        lg={1}
        sx={{ minWidth: "90px" }}
      />
      <PatientReviewDetail
        title="MCL"
        value={data?.mcl ?? "--"}
        size={detailSize}
        lg={1}
      />
      <PatientReviewDetail
        title="UCL"
        value={data?.ucl ?? "--"}
        size={detailSize}
        lg={1}
      />
    </PatientReviewDetailGroup>
  );
}
